<template>
  <v-container class="cmp-custom-text-settings dt-sidewindow submodule-root">
    <div class="dt-tabs-container submodule-root">
      <glayout :tabs="customTextSettingsTabs" tabPanelColor="secondary">
        <gtab id="assistant_intelligence" :showTabTitle="false">
          <grow>
            <gcol>
              <gbox :title="$t('ai_custom_text')">
                <AI_Templates
                  :custom_textsSettingsData="custom_textsSettingsData"
                  @updated="onTemplateUpdate"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="ai_agent_assistant">
          <grow>
            <gcol>
              <gbox :title="$t('ai_request_assistant')" h="298px">
                <div class="invoice-notifications">
                  <div
                    style="
                      border-bottom: 1px solid var(--sprt-85);
                      height: 32px;
                    "
                  >
                    <div class="dt-checkbox-control" style="height: 31px">
                      <div class="dt-checkbox-label ut-colcen">
                        {{$t('ai_turn_on_request_assistant')}}
                      </div>
                      <div class="ut-colcen">
                        <div class="dt-checkbox v2 s1">
                          <input
                            type="checkbox"
                            :name="'request_assistant_flag'"
                            :id="'request_assistant_flag'"
                            :checked="request_assistant_flag"
                            @click="
                              (e) =>
                                onRequestAssistantChange(
                                  'request_assistant_flag',
                                  e
                                )
                            "
                          />
                          <div class="checkmark"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                    <div class="request-ass-hint" v-if="request_assistant_flag">
                      To try out the new AI-powered request assistant just send a request email to <a :href="`mailto:${assistEmail}`">{{assistEmail}}</a>
                      <br>[NOTE: This feature is currently in alpha testing phase]
                    </div>
                </div>
              </gbox>
            </gcol>
            <gcol>
            </gcol>
          </grow>
        </gtab>
      </glayout>
    </div>
  </v-container>
</template>
<script>
import { createDTGridHost } from "../../../../dt-plugins/dt-grid/dt-grid.mixin";
import * as ActionTypes from "../../store/types";
import { SettingsStoreNamespace as storeNS } from "../../store";

// import { customTextGrid } from "./list-grid";

import {
  createGridHost,
  createSidewindowTabulation,
} from "../../../../dt-plugins/sidewindow";
import { mapKeyToAction, mapActionObject } from "../../../../store/global";
import { mapGetters } from "vuex";
import {
  createModalMixin,
  openModalRoute,
  closeModalRoute,
} from "../../../../dt-plugins/modal/modal.mixin";
// import ModalContainer from "@dtplugins/modal/modal-container";
import { custom_textsSettingsActions } from "../../store/custom_texts/actions";
import { confirmDelete } from "../../../../dt-plugins/confirmation/confirmation-common";
import { AccountingSettingsService } from '../../services/accounting-settings.service';
import * as AccountTypes from '../../../../store/app/account/types';

import AI_Templates from "./ai-templates";

export default {
  components: {
    // ModalContainer,
    AI_Templates,
  },
  mounted: function () {
    this[ActionTypes.Custom_textsSettingsData.FETCH.ALL]();
  },
  data: function () {
    return {
      // gridLayout: customTextGrid,
    };
  },
  mixins: [
    createDTGridHost(),
  ],
  computed: {
    ...mapGetters(storeNS, {
      custom_textsSettingsData: "custom_textsSettingsData",
    }),
    ...mapGetters({
        account: "account"
    }),
    customTextSettingsTabs: function () {
      return [
        // {
        //   route: "booking",
        //   value: this.$t("booking"),
        // },
        // {
        //   route: "royalties",
        //   value: this.$t("royalties"),
        // },
        // {
        //   route: "distribution",
        //   value: this.$t("distribution"),
        // },
        {
          route: "assistant_intelligence",
          value: this.$t("assistant_intelligence"),
        },
        {
          route: "ai_agent_assistant",
          value: this.$t("ai_agent_assistant"),
        },
      ];
    },
    request_assistant_flag: function () {      
      const settings = JSON.parse(this.account?.client?.settings);
      const template_id = settings?.AI?.prompt_template_ids?.agent_assistant?.request ? settings.AI.prompt_template_ids.agent_assistant.request : "";
      return template_id ? true : false;
    },
    clientID: function () {
      return this.$store?.getters?.account?.client?.clientID;
    },
    assistEmail: function () {
      return this.clientID ? `agent_assistant+${this.clientID}@details.eu` : ``;
    },
  },
  methods: {
    ...mapActionObject(storeNS, custom_textsSettingsActions),
    // tabSelectedRouting: function (tabId) {
    //   this.$router.push({
    //     name: "settings_custom_texts_tab",
    //     params: {
    //       tab: tabId,
    //     },
    //   });
    // },
    onTemplateUpdate: function (payload) {
      this[ActionTypes.Templates.UPDATE.SINGLE](payload);
    },
    onRequestAssistantChange: async function (name, event) {
      const checked = event.target.checked;

      const aiSettings = await AccountingSettingsService.aiUpdateFeatureProp("prompt_template_ids", "agent_assistant.request", (checked ? "30" : ""));
      // console.log("aiSettings", aiSettings);
      this.$store.dispatch(AccountTypes.GET_APP_INIT_DATA);
    },
    //MARK: Methods
  },
};
</script>

<style lang="scss">
.cmp-custom-text-settings {
  background: var(--bc-3, #f6f6f6);
  padding: 8px 32px;

  .dt-grid-layout {
    height: calc(100vh - 108px);
  }

  .invoice-notifications {
    .fc2 {
      label {
        &.fc2-label {
          white-space: pre-wrap !important;
        }
      }
    }
    .dt-checkbox-control {
      padding-left: 3px;
      margin-top: 0px;
      .dt-checkbox {
        max-width: 40px;
        // margin-right: 10px;
        margin-left: 5px;
        // margin-top: 5px;
      }
      .dt-checkbox-label {
        padding-left: 3px;
        flex: 1;
        max-width: 238px;
        color: var(--text-5);
        white-space: nowrap;
        font-size: 13px;
      }
    }
    .request-ass-hint{
      color: var(--text-5);
      padding: 10px;
    }
  }
}
</style>